module.exports = __webpack_public_path__ + "static/media/cq_cellulare b.8493219f.svg";